import { useOrgGroups } from 'features/user-group/user-group-list/api/useOrgGroups';
import { transformDataForTable } from 'features/user-group/user-group-list/components/groupListTableHelpers';

export const useGroupData = (groupId: string) => {
  const { data: orgGroupData, isLoading: orgGroupLoading } = useOrgGroups();
  const groupRows = transformDataForTable(
    (orgGroupData?.data ?? []).filter((item) => item.id === groupId),
  );
  const {
    name = '',
    description = '',
    roles: tenantList = [],
  } = groupRows[0] || {};

  return { name, description, tenantList, orgGroupLoading };
};
